/**
 * @generated SignedSource<<1af34100a6aa6317e1a028a1e9da0738>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutReviewStep_preCheckoutTransaction";
};
export type CheckoutReviewStep_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutReviewStep_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_preCheckoutTransaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "223d286c060146b07e4c3a294169a29e";

export default node;
